module.exports = __webpack_public_path__ + "img/schedule20261212_1.8b337edd.jpg";